import jApi from './jApi';

export default {
  getLoginActivity(params) {
    const api = jApi.generateApi();

    return api.get('/auth-service/studio/user-auth-activity', { params })
      .then(res => res.data);
  },

  forceLogout(params) {
    const api = jApi.generateApi();

    return api.post('/auth-service/studio/force-logout', null, { params }).then(res => res.data);
  },
};




// WEBPACK FOOTER //
// ./src/services/jApiLoginActivity.js